module.exports = __webpack_public_path__ + "img/light-bulb.d3999b0a.svg";